import { init as initApm, ApmBase } from '@elastic/apm-rum'
import { ApmConfig } from './types'

let apm: ApmBase | null = null

export const initializeApm = (config: ApmConfig): ApmBase => {
  if (!apm) {
    apm = initApm({
      logLevel: 'error',
      serverUrl: config.serverUrl,
      serviceName: config.serviceName,
      pageLoadTransactionName: 'page-load',
      ...config.options,
    })
  }
  return apm
}

export const getApmInstance = (): ApmBase | null => apm
